import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnDestroy,
  Output,
  Renderer2,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';
import { FilterProvider } from '../../services/filter-provider';
import { Util } from '../util';
import { IDropdownSettings, ListItem } from './multiselect.model';

export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectComponent),
  multi: true,
};
const noop = () => {};

@Component({
  selector: 'ng-multiselect-dropdown',
  templateUrl: 'multiselect.component.html',
  styleUrls: ['multiselect.component.scss'],
  providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR],
})
export class MultiSelectComponent implements ControlValueAccessor, OnDestroy {
  public _settings!: IDropdownSettings;
  public _data: ListItem[] = [];
  public selectedItems: ListItem[] = [];
  public selectedAllItems = [];
  public columnLengths = [];
  public modelItems: { id: string }[] = [];
  private id = Util.uuidv4();

  public isDropdownOpen = true;
  _placeholder = 'Select';
  filter: ListItem = new ListItem(this.data);
  defaultSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'text',
    disabledField: 'isDisabled',
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: false,
    limitSelection: -1,
    clearSearchFilter: true,
    maxHeight: 408,
    itemsShowLimit: 999999999999,
    searchPlaceholderText: 'Search',
    noDataAvailablePlaceholderText: 'No data available',
    closeDropDownOnSelection: false,
    showSelectedItemsAtTop: false,
    defaultOpen: false,
  };
  optionColumnLength: any[] = [];
  relatedSource: any;
  active = false;
  public unrelatedIndex!: number;
  public relatedIndex!: number;
  public unrelatedmodules!: number;

  @Input()
  public set placeholder(value: any) {
    if (value) {
      this._placeholder = value;
    } else {
      this._placeholder = 'Select';
    }
  }

  @Input()
  disabled = false;

  @Input()
  public set data(value: any[]) {
    if (!value) {
      this._data = [];
    } else {
      // const _items = value.filter((item: any) => {
      //   if (typeof item === 'string' || (typeof item === 'object' && item
      //   && item[this._settings.idField] && item[this._settings.textField])) {
      //     return item;
      //   }
      // });
      this._data = value.map((item: any) =>
        typeof item === 'string' || typeof item === 'number'
          ? new ListItem(item)
          : new ListItem({
              id: item[this._settings.idField],
              text: item[this._settings.textField],
              isDisabled: item[this._settings.disabledField],
              related: item['related'],
            }),
      );
      this.getIndexforLabls();
      this.calOptionsLength();
    }
  }

  @Input()
  public set settings(value: IDropdownSettings) {
    if (value) {
      this._settings = Object.assign(this.defaultSettings, value);
    } else {
      this._settings = Object.assign(this.defaultSettings);
    }
  }

  @Input()
  public set columnLength(value) {
    if (value) {
      this.columnLengths = Object.assign([], value);
    } else {
      this.columnLengths = Object.assign([], []);
    }
  }

  @Input()
  public set model(model) {
    if (model) {
      this.modelItems = Object.assign([], model);
    } else {
      this.modelItems = Object.assign([], []);
    }
  }

  @Input()
  public set reportGroupingSelectedItems(value) {
    if (value) {
      this.modelItems = value.map((item) => {
        return new ListItem({
          id: item[this._settings?.idField],
          text: item[this._settings?.textField],
          isDisabled: item[this._settings?.disabledField],
          related: item['related'],
        });
      });
    } else {
      this.modelItems = Object.assign([], []);
    }
  }

  @Output('onFilterChange')
  onFilterChange: EventEmitter<ListItem> = new EventEmitter<any>();
  @Output('onDropDownClose')
  onDropDownClose: EventEmitter<any> = new EventEmitter<any>();

  @Output('onSelect')
  onSelect: EventEmitter<ListItem> = new EventEmitter<any>();

  @Output('onDeSelect')
  onDeSelect: EventEmitter<ListItem> = new EventEmitter<any>();

  @Output('onSelectAll')
  onSelectAll: EventEmitter<ListItem[]> = new EventEmitter<any[]>();

  @Output('onDeSelectAll')
  onDeSelectAll: EventEmitter<ListItem[]> = new EventEmitter<any[]>();
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  onFilterTextChange($event) {
    this.onFilterChange.emit($event);
  }

  constructor(public filterProvider: FilterProvider, private el: ElementRef, protected _renderer: Renderer2) {
    window.addEventListener('popstate', this.closeOnPop);
  }

  onItemClick($event: any, item: ListItem) {
    if (this.disabled || item.isDisabled) {
      return false;
    }

    const found = this.isSelected(item);
    const allowAdd =
      this._settings.limitSelection === -1 ||
      (this._settings.limitSelection > 0 && this.selectedItems.length < this._settings.limitSelection);
    if (!found) {
      if (allowAdd) {
        this.addSelected(item);
      }
    } else {
      this.removeSelected(item, 'inside');
    }
    if (this._settings.singleSelection && this._settings.closeDropDownOnSelection) {
      this.closeDropdown(true);
    }
    return false;
  }

  calOptionsLength() {
    const value = this._data.length / 10;
    if (value) {
      const lengthArray: number[] = [];
      const covertedValue = Math.ceil(value);
      if (covertedValue === 0) {
        lengthArray.push(0);
        this.optionColumnLength = _.merge([], lengthArray);
      } else {
        for (let i = 0; i < covertedValue; i++) {
          lengthArray.push(i);
          this.optionColumnLength = _.merge([], lengthArray);
        }
      }
    }
  }

  getIndexforLabls() {
    const index = this._data.findIndex((dt) => dt.related === true);
    if (index > -1) {
      if (index > 10) {
        const rem = index - 10;
        this.relatedIndex = 10 - rem;
      } else {
        this.relatedIndex = index;
      }
    } else {
      this.relatedIndex = index;
    }

    const un_index = this._data.findIndex((dt) => dt.related === false);
    if (un_index > -1) {
      if (un_index > 10) {
        const value = un_index / 10;
        this.unrelatedmodules = Math.round(value);
        const rem = un_index - 10;
        this.unrelatedIndex = rem;
      } else {
        this.unrelatedmodules = 0;
        this.unrelatedIndex = un_index;
      }
    } else {
      this.unrelatedIndex = un_index;
    }
  }

  writeValue(value: any) {
    if (value !== undefined && value !== null && value.length > 0) {
      if (this._settings.singleSelection) {
        try {
          if (value.length >= 1) {
            const firstItem = value[0];
            this.selectedItems = [
              typeof firstItem === 'string' || typeof firstItem === 'number'
                ? new ListItem(firstItem)
                : new ListItem({
                    id: firstItem[this._settings.idField],
                    text: firstItem[this._settings.textField],
                    isDisabled: firstItem[this._settings.disabledField],
                  }),
            ];
          }
        } catch (e) {
          // console.error(e.body.msg);
        }
      } else {
        const _data = value.map((item: any) =>
          typeof item === 'string' || typeof item === 'number'
            ? new ListItem(item)
            : new ListItem({
                id: item[this._settings.idField],
                text: item[this._settings.textField],
                isDisabled: item[this._settings.disabledField],
                related: item['related'],
              }),
        );
        if (this._settings.limitSelection > 0) {
          this.selectedItems = _data.splice(0, this._settings.limitSelection);
        } else {
          this.selectedItems = _data;
        }
      }
    } else {
      this.selectedItems = [];
    }
    this.onChangeCallback(value);
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  // Set touched on blur
  @HostListener('blur')
  public onTouched() {
    this.closeDropdown(true);
    this.onTouchedCallback();
  }

  trackByFn(index, item) {
    return item.id;
  }

  isSelected(clickedItem: ListItem) {
    let found = false;
    const dataItem = [];
    this.modelItems.forEach((item) => {
      if (clickedItem.id === item.id) {
        found = true;
      }
    });

    return found;
  }

  isLimitSelectionReached(): boolean {
    return this._settings.limitSelection === this.selectedItems.length;
  }

  isAllItemsSelected(): boolean {
    // get disabld item count
    const itemDisabledCount = this._data.filter((item) => item.isDisabled).length;
    // take disabled items into consideration when checking
    return this._data.length === this.selectedItems.length + itemDisabledCount;
  }

  showButton(): boolean {
    if (!this._settings.singleSelection) {
      if (this._settings.limitSelection > 0) {
        return false;
      }
      // this._settings.enableCheckAll = this._settings.limitSelection === -1 ? true : false;
      return true; // !this._settings.singleSelection && this._settings.enableCheckAll && this._data.length > 0;
    } else {
      // should be disabled in single selection mode
      return false;
    }
  }

  itemShowRemaining(): number {
    return this.selectedItems.length - this._settings.itemsShowLimit;
  }

  setSelectedItems(items: any) {
    this.selectedAllItems = Object.assign([], items);
  }

  addSelected(item: ListItem) {
    if (this._settings.singleSelection) {
      this.selectedItems = [];
      this.selectedItems.push(item);
    } else {
      this.selectedItems.push(item);
    }
    this.onChangeCallback(this.emittedValue(this.selectedItems));
    this.onSelect.emit(this.emittedValue(item));
  }

  removeSelected(itemSel: ListItem, type: string) {
    this.selectedItems.forEach((item) => {
      if (itemSel.text === item.text) {
        this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
      }
    });
    this.onChangeCallback(this.emittedValue(this.selectedItems));
    if (type === 'inside') {
      this.onDeSelect.emit(this.emittedValue(itemSel));
    }
  }

  emittedValue(val: ListItem | ListItem[]): any {
    if (!val) return [];

    if (Array.isArray(val)) {
      // val.map((item) => {
      //   selected.push(this.objectify(item));
      // });
      return val.map((v) => this.objectify(v));
    }
    return this.objectify(val);
  }

  objectify(val: ListItem) {
    if (!this._settings) return {};

    const obj = {
      related: val.related,
    };
    obj[this._settings.idField] = val.id;
    obj[this._settings.textField] = val.text;
    obj[this._settings.disabledField] = val.isDisabled;
    return obj;
  }

  toggleDropdown(evt) {
    evt.preventDefault();
    if (this.disabled && this._settings.singleSelection) {
      return;
    }

    this._settings.defaultOpen = !this._settings.defaultOpen;
    const historyDDState = _.get(window.history.state, 'dropdownOpen', false);

    if (!this._settings.defaultOpen) {
      this.onDropDownClose.emit({
        status: true,
        key: this._settings.textField,
      });
      this.enableScroll();
      if (historyDDState && window.history.state && window.history.state.id === this.id) {
        //window.history.back();
      }
    } else {
      this.disableScroll();
      this.onDropDownClose.emit({
        status: false,
        key: this._settings.textField,
      });

      //TODOV4: Uncomment these changes in whole file
      // if (!historyDDState) {
      // 	window.history.pushState(
      // 		{ dropdownOpen: true, id: this.id },
      // 		"",
      // 		location.href
      // 	);
      // } else {
      // 	window.history.replaceState(
      // 		{ dropdownOpen: true, id: this.id },
      // 		"",
      // 		location.href
      // 	);
      //}
    }
  }

  closeDropdown(changeHistory: boolean) {
    if (this._settings.defaultOpen) {
      this._settings.defaultOpen = false;
      // clear search text
      if (this._settings.clearSearchFilter) {
        this.filter.text = '';
      }
      this.onDropDownClose.emit({
        status: true,
        key: this._settings.textField,
      });

      // const historyState = window.history.state;

      // if (
      // 	historyState &&
      // 	historyState.dropdownOpen &&
      // 	historyState.id === this.id
      // ) {
      // 	window.history.back();
      // }
      this.enableScroll();
    }
  }

  toggleSelectAll() {
    if (this.disabled) {
      return false;
    }
    if (!this.isAllItemsSelected()) {
      // filter out disabled item first before slicing
      this.selectedItems = this._data.filter((item) => !item.isDisabled).slice();
      this.onSelectAll.emit(this.emittedValue(this.selectedItems));
    } else {
      this.selectedItems = [];
      this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
    }
    this.onChangeCallback(this.emittedValue(this.selectedItems));
    return false;
  }

  enableScroll() {
    Array.from(document.getElementsByClassName('scroll-content')).forEach((_) => {
      _.classList.remove('remove_scroll');
    });

    const filterOverlay = document.getElementById('filter_overlay');

    if (filterOverlay) {
      filterOverlay.classList.remove('dd-overlay');
    }
  }

  disableScroll() {
    Array.from(document.getElementsByClassName('scroll-content')).forEach((_) => {
      _.classList.add('remove_scroll');
    });

    const filterOverlay = document.getElementById('filter_overlay');

    if (filterOverlay) {
      filterOverlay.classList.add('dd-overlay');
    }
  }

  private closeOnPop = (ev) => {
    if (ev !== null) {
      this.closeDropdown(false);
    }
  };

  ngOnDestroy() {
    window.removeEventListener('popstate', this.closeOnPop);
  }
}
